import type { HomepageSlotType } from "@/generated/prisma/enums";

export const EDITORIAL_LABELS = {
  homepage: {
    hero: "Fő sztori",
    mainFeature: "Vezető anyag",
    sideRelated: "További kiemelések",
    editorialRecommendation: "Szerkesztői ajánló",
    latestNews: "Friss hírek",
    hotTopics: "Most pörög",
    weeklyTopics: "A hét témái",
    weeklyMostRead: "A hét legolvasottabb cikkei",
    transfersRail: "Transzferfigyelő",
    transferNews: "Transzferhírek",
  },
  article: {
    checkThis: "Ezt is olvasd el",
    related: "Kapcsolódó anyagok",
  },
  worldCup: {
    latestNews: "Friss hírek",
    topNews: "Kiemelt hírek",
  },
} as const;

export const HOMEPAGE_BLOCK_LABELS: Record<string, string> = {
  hero: EDITORIAL_LABELS.homepage.hero,
  featuredGrid: EDITORIAL_LABELS.homepage.editorialRecommendation,
  transfersRail: EDITORIAL_LABELS.homepage.transfersRail,
  latestNews: EDITORIAL_LABELS.homepage.latestNews,
  leagueSection: "Liga fókusz",
  manualEditorialRow: EDITORIAL_LABELS.homepage.weeklyMostRead,
};

export function homepageBlockLabel(blockType: string) {
  return HOMEPAGE_BLOCK_LABELS[blockType] ?? blockType;
}

export function homepageSlotLabel(type: HomepageSlotType, index: number) {
  if (type === "MAIN_FEATURE") return EDITORIAL_LABELS.homepage.mainFeature;
  if (type === "SIDE_RELATED") return EDITORIAL_LABELS.homepage.sideRelated;
  if (type === "OLD_FEATURE") return EDITORIAL_LABELS.homepage.editorialRecommendation;
  if (type === "HOT_TOPIC") return EDITORIAL_LABELS.homepage.hotTopics;
  return `${type} ${index + 1}`;
}
